module.exports = __webpack_public_path__ + "media/images/bg_service_pr_sp-de9fdeee9182969b004890081e88f4db.jpg";